export default {
  currencySymbol: 'Q',
  table: {
    principal: 'Principal',
    bonus: 'Bono',
    promotional: 'Promocional'
  }
}
